module.exports = __webpack_public_path__ + "media/female_resultC.2426e088.mp3";